import React from 'react';

import { WebCopy, Input } from 'components';

interface URLInputProps {
  className: any;
  urlLabel: any;
  url: any;
  errors: any;
  handleUrlChanged: any;
}

export const URLInput: React.FC<URLInputProps> = ({
  className,
  urlLabel,
  url,
  errors,
  handleUrlChanged,
}) => {
  return (
    <>
      <Input
        className={className}
        error={!!errors.url}
        fullWidth
        type={'text'}
        label={urlLabel}
        value={url}
        onChange={handleUrlChanged}
      />
      {!!errors.url ? <WebCopy type="Error">{errors.url}</WebCopy> : null}
    </>
  );
};
